import type { FaireProductEntity } from "../../entity_types/product";

export const p_4vcg9ttkpz: FaireProductEntity = {
  token: "p_4vcg9ttkpz",
  type: "product",
  name: 'All Purpose Scissors-Orange-8"L',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/923b47c198b8025f4059d71734d34b5b42d64d94f8afdeb3dc8906892e192117.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5bdf00ba3c63138b94d4ed677c3dd0a92b008743ee676c574ab04e023c5080ec.jpeg",
    "https://cdn.faire.com/fastly/093b9ee9fb057d792e7896d23f7b78c4003797bea238ba143bea78ed16f2dc6f.jpeg",
    "https://cdn.faire.com/fastly/5fb445d9774293bbfddf468e1444a042af60e7bef383b98abc064ef698d1f1df.jpeg",
    "https://cdn.faire.com/fastly/9ef00883db9faa6c0d5444cc1538d5d6d27f857315edfd66c7f6b466c1731a6f.jpeg",
  ],
  priceDollars: 6,
  description:
    "Discover the versatility of our All-Purpose Scissors! Designed for comfort and precision, these orange handled scissors are perfect for a variety of tasks, from crafting to everyday household use. The sleek acrylic handles provide a comfortable grip, making cutting effortless. Stylish and functional, they are a must-have addition to your home or office.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:07.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
